import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/CopyMeetingItemsToMeetingWizard.scss';
import classNames from 'classnames';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, redirect, setTableParams } from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import {
  copyMeetingItemsToMeeting,
  readMeetingItems,
  reorderMeetingItems,
} from '../redux/actions/table/all_meetings';
import { SubmissionError } from 'redux-form';
import CopyMeetingItemsToMeetingForm from '../forms/copy_meeting_items_to_meeting/CopyMeetingItemsToMeetingForm';
import MoveSelectedMeetingItemsForm from '../forms/move_selected_meeting_items_wizard/MoveMeetingItemForm';
import * as _ from 'lodash';

@withRouter
@mapStateToProps((state) => ({
  selected_rows: _.get(
    state.table,
    'all_meetings.copy_meeting_items_to_meeting_wizard.selected_rows'
  ),
  sorted_items: _.get(
    state.table,
    'all_meetings.copy_meeting_items_to_meeting_wizard.sorted_items'
  ),
}))
class CopyMeetingItemsToMeetingWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      target_meeting_id: null,
      target_meeting_items: [],
    };
    this.redirect_after_copy = false;
  }

  steps = [
    {
      id: '01',
      title: __('wizard.meeting.label.add-to-existing-meeting'),
    },
    {
      id: '02',
      title: __('move-meeting-item.selected-item'),
    },
  ];

  _getSelectedMeetingItemIds() {
    const { selected_rows, sorted_items } = this.props;

    return _.map(
      _.filter(sorted_items, (item) => _.includes(selected_rows, item.id)),
      'id'
    );
  }

  _getMeetingItemOptions(items) {
    return _.map(items, (item) => ({
      value: item.id,
      label:
        item.type == 'task'
          ? '—\u00A0' + item.task_title
          : item.type == 'topic'
          ? '—\u00A0' + item.title
          : item.title,
      blackMarkedValue: item.type === 'group',
    }));
  }

  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }

  @autobind
  _handleMeetingSubmit(formData) {
    const { child_meeting_id } = formData;
    const {
      sorted_items,
      match: {
        params: { meeting },
      },
    } = this.props;

    if (!child_meeting_id) {
      throw new SubmissionError({ child_meeting_id: ['Field required'] });
    }

    if (_.toString(child_meeting_id) === _.toString(meeting)) {
      this.setState({
        active: '02',
        target_meeting_id: child_meeting_id,
        target_meeting_items: sorted_items || [],
      });

      return;
    }

    return readMeetingItems(child_meeting_id).then(({ response }) => {
      this.setState({
        active: '02',
        target_meeting_id: child_meeting_id,
        target_meeting_items: response.data || [],
      });
    });
  }

  @autobind
  _handlePositionSubmit(formData) {
    const {
      match: {
        params: { meeting },
      },
    } = this.props;
    const { target_meeting_id, target_meeting_items } = this.state;
    const meeting_items = this._getSelectedMeetingItemIds();
    const current_item_ids = _.map(target_meeting_items, 'id');

    if (!_.isEmpty(target_meeting_items) && !formData.selected_item_id) {
      throw new SubmissionError({ selected_item_id: ['Field required'] });
    }

    return copyMeetingItemsToMeeting(meeting, {
      meeting_items,
      child_meeting_id: target_meeting_id,
    })
      .then(() => readMeetingItems(target_meeting_id))
      .then(({ response }) => {
        const updated_items = response.data || [];
        const updated_item_ids = _.map(updated_items, 'id');
        const copied_item_ids = _.filter(
          updated_item_ids,
          (id) => !_.includes(current_item_ids, id)
        );

        if (_.isEmpty(copied_item_ids) || !formData.selected_item_id) {
          return;
        }

        const ordered_item_ids = _.filter(
          updated_item_ids,
          (id) => !_.includes(copied_item_ids, id)
        );
        const target_index = _.indexOf(
          ordered_item_ids,
          formData.selected_item_id
        );
        const insertion_index =
          target_index + (formData.move_action === 'before' ? 0 : 1);

        ordered_item_ids.splice(insertion_index, 0, ...copied_item_ids);

        return reorderMeetingItems(target_meeting_id, ordered_item_ids);
      })
      .then(() => {
        this.props.onClose();

        if (this.redirect_after_copy) {
          redirect('/meetings/' + target_meeting_id);
        }

        setTableParams('all_meetings', {
          forceUpdate: true,
        });

        setTimeout(
          () =>
            setNotification(
              __(
                'meetings.all-meetings.add-new.notification.selected-items-have-been-added-to-the-meeting'
              )
            ),
          25
        );
      });
  }

  render() {
    const active =
      _.find(this.steps, (item) => item.id === this.state.active) ||
      _.first(this.steps);
    const { target_meeting_items } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.titleBar}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.meeting.title.copy-meeting-items-to-existing-meeting'
                )}
              </span>
              <span>{active.title}</span>
            </div>
            <div className={styles.right}>
              <span>{active.id}</span>
              <span>{_.last(this.steps).id}</span>
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(this.steps, (step, i) => (
              <div
                key={i}
                className={classNames(
                  styles.step,
                  active.id == step.id && styles.active,
                  step.id < active.id && styles.completed
                )}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.body}>
          {active.id === '01' && (
            <CopyMeetingItemsToMeetingForm
              initialValues={{
                new_meeting: false,
              }}
              onSubmit={this._handleMeetingSubmit}
            />
          )}
          {active.id === '02' && (
            <MoveSelectedMeetingItemsForm
              onSubmit={this._handlePositionSubmit}
              onBack={() => this._setActiveStep('01')}
              onCancel={this.props.onClose}
              onSubmitModeChange={(redirectAfterCopy) => {
                this.redirect_after_copy = redirectAfterCopy;
              }}
              submitText={__('button.copy')}
              secondarySubmitText={__('button.add-go-to-meeting')}
              initialValues={{
                move_action: 'after',
              }}
              options={this._getMeetingItemOptions(target_meeting_items)}
            />
          )}
        </div>
      </>
    );
  }
}

export default CopyMeetingItemsToMeetingWizard;
